module.exports = __webpack_public_path__ + "img/sticker01.105e9ab4.png";